import { getStoredValue, storeValue } from '../../utils/localStorage';
import { PAGE_SIZE_OPTIONS } from './pageSizeOptions';

const PAGE_SIZE_STORAGE_KEY = 'downloadLogsPageSize';
const DEFAULT_PAGE_SIZE = 100;

const isValidPageSize = (value: unknown): value is number =>
  typeof value === 'number' && PAGE_SIZE_OPTIONS.includes(value);

/** Reads the last-chosen page size from localStorage; falls back to 100 if unset, invalid, or unavailable. */
export const getStoredPageSize = (): number =>
  getStoredValue(PAGE_SIZE_STORAGE_KEY, isValidPageSize, DEFAULT_PAGE_SIZE);

export const storePageSize = (size: number): void =>
  storeValue(PAGE_SIZE_STORAGE_KEY, size);
